import type { LessonClassDetail as LessonClassDetailData } from '@mathflat/domain/LessonClass'

import { EMPTY_NUMBER_ID } from '@/constant/common'

import { DTO } from '../DTO'

export class LessonClassDetail extends DTO {
  id: LessonClassDetailData['id'] = EMPTY_NUMBER_ID
  name = ''
  grade = 1
  index = 1
  teacherIdList: LessonClassDetailData['teacherIdList'] = []
  studentIdList: LessonClassDetailData['studentIdList'] = []

  constructor(data: Partial<LessonClassDetailData> = {}) {
    super()
    this.update<LessonClassDetail>(this, data)
  }
}
